//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import UrlParse from 'url-parse';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/player.svg';
import { EMPTY_PIXEL } from '~/const/images';
import { formatPrismicImage } from '~/helpers/image-helper';
import Countdown from '~/components/molecules/Editorial/Homepage/Countdown.vue';

var GlobalRichText = () => import(
/* webpackChunkName:"global-editorial" */
'~/components/atoms/Editorial/Global/GlobalRichText.vue');

var POSITION = {
  center: '',
  left: 'justify-content-lg-start',
  right: 'justify-content-lg-end'
};
export default {
  name: 'HomeBlockEvent',
  components: {
    GlobalRichText,
    Countdown
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  computed: {
    currentPayload() {
      var _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23;

      return {
        image: {
          small: formatPrismicImage((_ref23 = this.payload) != null ? (_ref23 = _ref23.primary) != null ? (_ref23 = _ref23.background_image) != null ? (_ref23 = _ref23.small) != null ? _ref23.url : _ref23 : _ref23 : _ref23 : _ref23) || EMPTY_PIXEL,
          medium: formatPrismicImage((_ref22 = this.payload) != null ? (_ref22 = _ref22.primary) != null ? (_ref22 = _ref22.background_image) != null ? (_ref22 = _ref22.medium) != null ? _ref22.url : _ref22 : _ref22 : _ref22 : _ref22) || EMPTY_PIXEL,
          large: formatPrismicImage((_ref21 = this.payload) != null ? (_ref21 = _ref21.primary) != null ? (_ref21 = _ref21.background_image) != null ? (_ref21 = _ref21.large) != null ? _ref21.url : _ref21 : _ref21 : _ref21 : _ref21) || EMPTY_PIXEL,
          xlarge: formatPrismicImage((_ref20 = this.payload) != null ? (_ref20 = _ref20.primary) != null ? (_ref20 = _ref20.background_image) != null ? (_ref20 = _ref20.xlarge) != null ? _ref20.url : _ref20 : _ref20 : _ref20 : _ref20) || EMPTY_PIXEL,
          alt: ((_ref19 = this.payload) != null ? (_ref19 = _ref19.primary) != null ? _ref19.alt : _ref19 : _ref19) || '',
          opacity: ((_ref18 = this.payload) != null ? (_ref18 = _ref18.primary) != null ? _ref18.opacity : _ref18 : _ref18) || ''
        },
        video: {
          video_mp4: formatPrismicImage((_ref17 = this.payload) != null ? (_ref17 = _ref17.primary) != null ? (_ref17 = _ref17.video_mp4) != null ? _ref17.url : _ref17 : _ref17 : _ref17, [], '', 'video') || '',
          video_webm: formatPrismicImage((_ref16 = this.payload) != null ? (_ref16 = _ref16.primary) != null ? (_ref16 = _ref16.video_webm) != null ? _ref16.url : _ref16 : _ref16 : _ref16, [], '', 'video') || ''
        },
        backgroundColor: ((_ref15 = this.payload) != null ? (_ref15 = _ref15.primary) != null ? _ref15.background_color : _ref15 : _ref15) || '',
        title: ((_ref14 = this.payload) != null ? (_ref14 = _ref14.primary) != null ? _ref14.title : _ref14 : _ref14) || {},
        subtitle: ((_ref13 = this.payload) != null ? (_ref13 = _ref13.primary) != null ? _ref13.subtitle : _ref13 : _ref13) || {},
        textColor: ((_ref12 = this.payload) != null ? (_ref12 = _ref12.primary) != null ? _ref12.text_color : _ref12 : _ref12) || {},
        countdown: ((_ref11 = this.payload) != null ? (_ref11 = _ref11.primary) != null ? _ref11.countdown : _ref11 : _ref11) || '',
        days: ((_ref10 = this.payload) != null ? (_ref10 = _ref10.primary) != null ? _ref10.days : _ref10 : _ref10) || '',
        hours: ((_ref9 = this.payload) != null ? (_ref9 = _ref9.primary) != null ? _ref9.hours : _ref9 : _ref9) || '',
        minutes: ((_ref8 = this.payload) != null ? (_ref8 = _ref8.primary) != null ? _ref8.minutes : _ref8 : _ref8) || '',
        seconds: ((_ref7 = this.payload) != null ? (_ref7 = _ref7.primary) != null ? _ref7.seconds : _ref7 : _ref7) || '',
        desktopLayout: ((_ref6 = this.payload) != null ? (_ref6 = _ref6.primary) != null ? _ref6.desktop_layout : _ref6 : _ref6) || 'center',
        cta: {
          text: ((_ref5 = this.payload) != null ? (_ref5 = _ref5.primary) != null ? _ref5.cta_text : _ref5 : _ref5) || '',
          url: new UrlParse(((_ref4 = this.payload) != null ? (_ref4 = _ref4.primary) != null ? (_ref4 = _ref4.cta_url) != null ? _ref4.url : _ref4 : _ref4 : _ref4) || '').pathname,
          tracking: {
            data: {
              event_category: ((_ref3 = this.payload) != null ? (_ref3 = _ref3.primary) != null ? _ref3.cta_event_category : _ref3 : _ref3) || '',
              event_action: ((_ref2 = this.payload) != null ? (_ref2 = _ref2.primary) != null ? _ref2.cta_event_action : _ref2 : _ref2) || '',
              event_label: ((_ref = this.payload) != null ? (_ref = _ref.primary) != null ? _ref.cta_event_label : _ref : _ref) || ''
            }
          }
        }
      };
    }

  },
  methods: {
    contentPosition(value) {
      return POSITION[value];
    }

  }
};